import type { LucideIcon } from 'lucide-react'
import * as React from 'react'
import { forwardRef } from 'react'

export const SettingsIcon: LucideIcon = forwardRef(({ size = 24, color = 'white', ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.9688 11.5761C12.8041 11.5761 13.4814 10.8986 13.4814 10.0632C13.4814 9.22776 12.8041 8.55029 11.9688 8.55029C11.1336 8.55029 10.4563 9.22776 10.4563 10.0632C10.4563 10.8986 11.1336 11.5761 11.9688 11.5761Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.0062 12.2577C10.2194 12.2577 8.76917 13.6833 8.72346 15.458H15.289C15.2433 13.6833 13.7931 12.2577 12.0062 12.2577Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M20.7658 10.0466H19.2159C19.058 9.42727 18.8211 8.82876 18.5095 8.26766L19.5857 7.19119C20.0677 6.70906 20.0677 5.92768 19.5857 5.44555L18.5635 4.41895C18.0814 3.93682 17.3002 3.93682 16.8182 4.41895L15.8209 5.42062C15.2433 5.05902 14.62 4.77639 13.9676 4.58105V3.23441C13.9676 2.55278 13.4149 2 12.7334 2H11.2832C10.6017 2 10.049 2.55278 10.0449 3.23441V4.44389C9.33015 4.60599 8.6445 4.87199 8.00457 5.23358L7.19011 4.41895C6.70808 3.93682 5.92686 3.93682 5.44484 4.41895L4.41845 5.44555C3.94058 5.92768 3.94058 6.70906 4.41845 7.19119L5.16642 7.93932C4.76335 8.59185 4.46 9.30258 4.26886 10.0466H3.23416C2.55267 10.0466 2 10.6035 2 11.2851V12.7357C2 13.4173 2.55267 13.9701 3.23416 13.9701H4.28132C4.48078 14.7057 4.78413 15.404 5.1872 16.0482L4.41845 16.8171C3.94058 17.2993 3.94058 18.0806 4.41845 18.5628L5.44484 19.5894C5.92686 20.0673 6.70808 20.0673 7.19011 19.5894L8.03781 18.7415C8.66944 19.0865 9.34677 19.3441 10.049 19.5021V20.7656C10.049 21.4472 10.6017 22 11.2832 22H12.7293C13.4108 22 13.9634 21.4472 13.9634 20.7656V19.3649C14.6034 19.1737 15.2142 18.8994 15.7835 18.5503L16.814 19.5852C17.2961 20.0673 18.0773 20.0673 18.5593 19.5852L19.5816 18.5628C20.0636 18.0806 20.0636 17.2993 19.5816 16.8171L18.4928 15.724C18.8003 15.1712 19.0413 14.5769 19.2034 13.9659H20.7658C21.4473 13.9659 22 13.4131 22 12.7315V11.281C22 10.5952 21.4432 10.0424 20.7575 10.0424L20.7658 10.0466ZM11.7486 17.9227C8.46998 17.9227 5.81051 15.2627 5.81051 11.9834C5.81051 8.69992 8.46998 6.04406 11.7486 6.04406C15.0272 6.04406 17.6867 8.70407 17.6867 11.9834C17.6867 15.2627 15.0272 17.9227 11.7486 17.9227Z'
        fill={color}
      />
    </svg>
  )
})

SettingsIcon.displayName = 'SettingsIcon'
